import { render, staticRenderFns } from "./CentreProfilePage.vue?vue&type=template&id=023066a9&scoped=true&"
import script from "./CentreProfilePage.vue?vue&type=script&lang=js&"
export * from "./CentreProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./CentreProfilePage.vue?vue&type=style&index=0&id=023066a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023066a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader})
